/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackType = {
  BUG: "BUG",
  IMPROVEMENT: "IMPROVEMENT",
  ERROR: "ERROR",
  FEATURE_REQUEST: "FEATURE_REQUEST",
  QUESTION: "QUESTION",
  OTHER: "OTHER",
} as const;
